import React from "react";
import { FormHelperText, TextField } from "@material-ui/core";
import { FormikProps, Field } from "formik";
import { required } from "Tools/FormValidations";

import { STFormControl } from "./styles";
import get from "lodash/get";
import { computed } from "mobx";
import Autocomplete, { AutocompleteInputChangeReason } from "@material-ui/lab/Autocomplete/Autocomplete";

interface IProps<T, ItemType> {
  disabled?: boolean;
  className?: string;
  formikProps: FormikProps<T>;
  fieldName: keyof T;
  items: ItemType[];
  keyAsTitle: keyof ItemType;
  keyAsValue: keyof ItemType;
  keyAsOptionDisabled: keyof ItemType;
  keyAsDescription?: keyof ItemType;
  label: string;
  onChange?: (item: any) => void;
  optionalField?: boolean;
}

class FormSimpleSelect<T, ItemType> extends React.Component<IProps<T, ItemType>> {
  @computed get value() {
    const currentValue = get(this.props.formikProps.values, this.props.fieldName);
    if (currentValue === null || currentValue === undefined) {
      return null;
    }
    return this.props.items.find((item) => item[this.props.keyAsValue as string] === currentValue) || null;
  }

  @computed get touched() {
    return get(this.props.formikProps.touched, this.props.fieldName);
  }

  @computed get errors() {
    return get(this.props.formikProps.errors, this.props.fieldName);
  }

  handleChange = (event: any) => {
    const selectedItem = this.props.items.find(
      (item) => item[this.props.keyAsTitle as string] === event.target.innerText
    );
    this.props.formikProps.setFieldValue(
      this.props.fieldName as string,
      selectedItem ? selectedItem[this.props.keyAsValue as string] : ""
    );
    if (this.props.onChange) {
      this.props.onChange(selectedItem[this.props.keyAsValue as string]);
    }
  };

  handleInputChange = (reason: AutocompleteInputChangeReason) => {
    if (reason === "clear" || reason === "input") {
      this.props.formikProps.setFieldValue(this.props.fieldName as string, "");
    }
  };

  render() {
    return (
      <Field
        name={this.props.fieldName}
        validate={this.props.optionalField ? null : required}
        render={() => (
          <STFormControl className={this.props.className} error={this.touched && !!this.errors}>
            <Autocomplete
              options={this.props.items}
              getOptionLabel={(item) => item[this.props.keyAsTitle as string]}
              getOptionDisabled={(item) => item[this.props.keyAsOptionDisabled as string]}
              value={this.value}
              disableClearable
              autoComplete={false}
              disabled={this.props.disabled}
              onChange={this.handleChange}
              onInputChange={(event: any, value: any, reason: AutocompleteInputChangeReason) =>
                this.handleInputChange(reason)
              }
              renderInput={(params: any) => <TextField {...params} label={this.props.label} />}
            />
            {this.touched && this.errors && <FormHelperText>{this.errors}</FormHelperText>}
          </STFormControl>
        )}
      />
    );
  }
}

export default FormSimpleSelect;
